import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostUpdateBalance = (params, setIsOpen) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_BALANCE_GROUPS_CASHIERS
            });
            setIsOpen(false);
            dispatch(Action.SetViewGroups({
                id: params.id
            }))
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateBalance as SetPostUpdateBalance
}